import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const WhyFreezeDriedRawRoot = styled('div', {
  background: '$tertiary-200',
  padding: '$6 $2',
})

export const WhyFreezeDriedRawContainer = styled('div', {
  maxWidth: '1200px',
  margin: '0 auto',
  textAlign: 'center',
})

export const Headline = styled('h2', {
  fontFamily: '$display',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  marginBottom: '$5',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})

export const ContentRow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '400px',
  width: '100%',
  margin: 'auto',

  '@bp2': {
    flexDirection: 'row',
    gap: '$4',
    maxWidth: 'none',
    justifyContent: 'center',
  },
})

export const ImageColumn = styled('div', {
  position: 'relative',
  width: '100%',
  aspectRatio: '345/222',

  '@bp2': {
    width: '400px',
    height: '459px',
    aspectRatio: 'none',
    flexShrink: 0,
  },
})

export const BenefitsList = styled('div', {
  textAlign: 'left',
  width: '100%',
  padding: '$5 0 0',

  '@bp2': {
    width: '400px',
    padding: 0,
  },
})

export const BenefitItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$1',
  padding: '16px 0',
  borderBottom: '1px solid $accent-black',

  '&:first-child': {
    borderTop: '1px solid $accent-black',
  },
})

export const BenefitLabel = styled(Text, {
  fontFamily: '$labels',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
})

export const BenefitDescription = styled(Text, {})
